(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["destin-carrusel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var posiciones = {};

    window.moverCarrusel = function(id, dir) {
      var track = document.getElementById('track-' + id);

      if (!track) return;

      var card = track.querySelector('.destin-carrusel__card');

      if (!card) return;

      var gap = 16;
      var cardW = card.getBoundingClientRect().width + gap;
      var containerW = track.parentElement.getBoundingClientRect().width;
      var visibles = Math.max(1, Math.floor(containerW / cardW));
      var total = track.children.length;

      posiciones[id] = posiciones[id] || 0;
      posiciones[id] += dir;

      var max = total - visibles;

      if (posiciones[id] < 0) {
        posiciones[id] = 0;
      }

      if (posiciones[id] > max) {
        posiciones[id] = max;
      }

      track.style.transform =
        'translateX(-' + (posiciones[id] * cardW) + 'px)';
    };
  })();

  } catch(e) { console.error(e); }
})();
})();
